export const createSharedCallback = <Data>(
  defaultCallback?: () => void,
): [(callback: (data: Data) => void) => void, () => void, (data: Data) => void] => {
  const sharedStore: {
    callback: undefined | ((data: Data) => void);
    registerCallback: (callback: (data: Data) => void) => void;
    unregisterCallback: () => void;
    executeCallback: (data: Data) => void;
  } = {
    callback: defaultCallback,
    registerCallback: (callback) => {
      sharedStore.callback = callback;
    },
    unregisterCallback: () => {
      sharedStore.callback = undefined;
    },
    executeCallback: (data) => {
      if (sharedStore.callback) {
        sharedStore.callback(data);
      }
    },
  };

  return [sharedStore.registerCallback, sharedStore.unregisterCallback, sharedStore.executeCallback];
};

export default createSharedCallback;
